import React from 'react'
import Header from "../Sub/Header";
import Footer from "../Sub/Footer";
import ITRSection from '../Sub/ITRSection'
import CallBack from '../Sub/CallBack';
import FaqSection from "../Sub/FaqSection"
function ITR() {
  return (
    <>
    <Header  />
     <ITRSection />
    
     <CallBack />
     <FaqSection />
     <Footer />

     </>
    
  )
}

export default ITR
